// extracted by mini-css-extract-plugin
module.exports = {"raceInfo":"_93b7a34","raceLink":"_6b561cc","race":"_47a44fd","chevron":"_e300a5d","eachWay":"_7a732cd","time":"_ac0bae1"};